// extracted by mini-css-extract-plugin
module.exports = {"Button":"button_Button__1cOiG","Success":"button_Success__tdKvJ","Danger":"button_Danger__17kYn"};